import React from 'react';
import { graphql } from 'gatsby';
import SiteHeader from '../components/SiteHeader/SiteHeader';
import Container from '../components/Container/Container';
import ParagraphHeader from '../components/Paragraph/ParagraphHeader';
import Paragraph from '../components/Paragraph/Paragraph';
import { GatsbyImage } from 'gatsby-plugin-image';

const TapetyDekoracyjne = ({ data }) => {
  return (
    <>
      <SiteHeader
        image={data.file.childImageSharp.gatsbyImageData}
        text='Tapety dekoracyjne'
      />
      <Container padding='32px 16px' width='740px'>
        <ParagraphHeader>Tapety dekoracyjne</ParagraphHeader>
        <Paragraph>
          Tapety "rolkowe" produkowane są na różnych podłożach (papier,
          flizelina), z zewnątrz prezentując wzory o przeróżnej tematyce,
          drukowane na papierze, winylu, metalu, trawie morskiej lub tkaninie.
          Rolka tapety najczęściej występuje w rozmiarach 0.53 x 10.05m, ale
          coraz częściej mamy do czynienia z rolkami szerszymi - 0.7m lub nawet
          powyżej 1 metra. Rodzaj podłoża decyduje o sposobie montażu, natomiast
          warstwa zewnętrzna w zależności od swoich parametrów decyduje o
          miejscu w którym chcemy położyć tapetę. W pomieszczeniach narażonych
          na zabrudzenie i mających kontakt z wilgocią praktyczniej jest użyć
          tapet wykonanych z winylu, foliowanych, lub pokrywanych laminatem. W
          sypialniach i na ścianach ekspozycyjnych można sobie pozwolić na
          dowolność materiału, gdyż tu w szczególności liczy się efekt
          dekoracyjny, gra świateł i nadanie indywidualnego stylu naszemu
          wnętrzu. W naszym salonie chętnie pomożemy Państwu wybrać materiał i
          wzór odpowiedni dla danego pomieszczenia i zgodny z Państwa
          oczekiwaniami.
        </Paragraph>
        <GatsbyImage
          image={data.wallpaperImage.childImageSharp.gatsbyImageData}
        />
      </Container>
    </>
  );
};

export const query = graphql`
  {
    file(name: { eq: "wallpapers" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, quality: 80)
      }
    }
    wallpaperImage: file(name: { eq: "wallpaper-decorative" }) {
      childImageSharp {
        gatsbyImageData(placeholder: BLURRED, quality: 80)
      }
    }
  }
`;

export default TapetyDekoracyjne;
